export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_OGRE_complete_6.0f18bd50.jpg";